'use strict';

var __makeTemplateObject =
  (void 0 && (void 0).__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', {
        value: raw,
      });
    } else {
      cooked.raw = raw;
    }

    return cooked;
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.generateIconLeftPosition =
  exports.generateLabelPosition =
  exports.generateInputFontSize =
  exports.generateInputHeight =
  exports.generateHintColor =
  exports.generateIconColor =
  exports.generateIconButtonPosition =
  exports.generateIconButtonSize =
  exports.generateLabelFontColor =
  exports.generateLabelFontSize =
  exports.generateInputColor =
  exports.generateInputView =
  exports.generateInputGeometricLine =
  exports.generateEllipsisContent =
  exports.generateGapLeftRight =
  exports.generateGap =
  exports.generateTextDisabled =
    void 0;

var styled_components_1 = require('styled-components');

var components_1 = require('../../../constants/components');

var constants_1 = require('./constants');

var generateTextDisabled = function generateTextDisabled(_a) {
  var theme = _a.theme,
    disabled = _a.disabled;

  if (disabled) {
    return styled_components_1.css(
      templateObject_1 ||
        (templateObject_1 = __makeTemplateObject(
          ['\n      color: ', ';\n    '],
          ['\n      color: ', ';\n    ']
        )),
      theme.transparent[25]
    );
  }

  return '';
};

exports.generateTextDisabled = generateTextDisabled;

var generateGap = function generateGap(_a) {
  var shape = _a.shape,
    $size = _a.$size;

  if ($size !== components_1.INPUT_SIZES.medium) {
    return styled_components_1.css(
      templateObject_2 ||
        (templateObject_2 = __makeTemplateObject(
          ['\n      padding-bottom: 4px;\n    '],
          ['\n      padding-bottom: 4px;\n    ']
        ))
    );
  }

  switch (shape) {
    case components_1.SHAPES.geometric:
      return styled_components_1.css(
        templateObject_3 ||
          (templateObject_3 = __makeTemplateObject(
            ['\n        padding: 0;\n      '],
            ['\n        padding: 0;\n      ']
          ))
      );

    case components_1.SHAPES.rounded:
      return styled_components_1.css(
        templateObject_4 ||
          (templateObject_4 = __makeTemplateObject(
            ['\n        padding: 0 12px;\n      '],
            ['\n        padding: 0 12px;\n      ']
          ))
      );

    case components_1.SHAPES.circular:
      return styled_components_1.css(
        templateObject_5 ||
          (templateObject_5 = __makeTemplateObject(
            ['\n        padding: 0 20px;\n      '],
            ['\n        padding: 0 20px;\n      ']
          ))
      );

    default:
      return styled_components_1.css(
        templateObject_6 || (templateObject_6 = __makeTemplateObject([''], ['']))
      );
  }
};

exports.generateGap = generateGap;

var getInputGap = function getInputGap(_a) {
  var shape = _a.shape,
    $size = _a.$size;

  switch (shape) {
    case components_1.SHAPES.geometric:
      return (
        constants_1.ICON_SIZE[$size] +
        constants_1.INPUT_PADDING_GEOMETRIC[$size].withIcon +
        constants_1.INPUT_PADDING_GEOMETRIC[$size].icon
      );

    case components_1.SHAPES.rounded:
      return (
        constants_1.ICON_SIZE[$size] +
        constants_1.INPUT_PADDING_ROUNDED[$size].withIcon +
        constants_1.INPUT_PADDING_ROUNDED[$size].icon
      );

    case components_1.SHAPES.circular:
      return (
        constants_1.ICON_SIZE[$size] +
        constants_1.INPUT_PADDING_CIRCULAR[$size].withIcon +
        constants_1.INPUT_PADDING_CIRCULAR[$size].icon
      );

    default:
      return 0;
  }
};

var getInputDefaultGap = function getInputDefaultGap(_a) {
  var shape = _a.shape,
    $size = _a.$size;

  switch (shape) {
    case components_1.SHAPES.geometric:
      return constants_1.INPUT_PADDING_GEOMETRIC[$size].default;

    case components_1.SHAPES.rounded:
      return constants_1.INPUT_PADDING_ROUNDED[$size].default;

    case components_1.SHAPES.circular:
      return constants_1.INPUT_PADDING_CIRCULAR[$size].default;

    default:
      return 0;
  }
};

var generateGapLeftRight = function generateGapLeftRight(_a) {
  var $icon = _a.$icon,
    shape = _a.shape,
    $size = _a.$size,
    $iconLeft = _a.$iconLeft;
  var gap = getInputGap({
    shape: shape,
    $size: $size,
  });

  var defaultGap = getInputDefaultGap({
    shape: shape,
    $size: $size,
  });

  if ($size === components_1.INPUT_SIZES.medium) {
    return styled_components_1.css(
      templateObject_7 ||
        (templateObject_7 = __makeTemplateObject(
          ['\n      padding-right: ', 'px;\n      padding-left: ', 'px;\n    '],
          ['\n      padding-right: ', 'px;\n      padding-left: ', 'px;\n    ']
        )),
      $icon ? gap : defaultGap,
      $iconLeft ? gap : defaultGap
    );
  }

  return '';
};

exports.generateGapLeftRight = generateGapLeftRight;

var generateEllipsisContent = function generateEllipsisContent() {
  return styled_components_1.css(
    templateObject_8 ||
      (templateObject_8 = __makeTemplateObject(
        ['\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  '],
        ['\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  ']
      ))
  );
};

exports.generateEllipsisContent = generateEllipsisContent;

var generateInputGeometricLine = function generateInputGeometricLine(_a) {
  var theme = _a.theme,
    shape = _a.shape,
    color = _a.color,
    error = _a.error,
    focused = _a.focused;
  return (
    shape === components_1.SHAPES.geometric &&
    styled_components_1.css(
      templateObject_9 ||
        (templateObject_9 = __makeTemplateObject(
          [
            "\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: -2px;\n        left: 0;\n        width: 100%;\n        height: 2px;\n        background-color: ",
            ";\n        z-index: 1;\n      }\n\n      &::before {\n        content: '';\n        position: absolute;\n        bottom: -2px;\n        left: 0;\n        width: ",
            ';\n        height: 2px;\n        transition: width 0.2s ease, background-color 0.2s ease;\n        background-color: ',
            ';\n        z-index: 2;\n      }\n    ',
          ],
          [
            "\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: -2px;\n        left: 0;\n        width: 100%;\n        height: 2px;\n        background-color: ",
            ";\n        z-index: 1;\n      }\n\n      &::before {\n        content: '';\n        position: absolute;\n        bottom: -2px;\n        left: 0;\n        width: ",
            ';\n        height: 2px;\n        transition: width 0.2s ease, background-color 0.2s ease;\n        background-color: ',
            ';\n        z-index: 2;\n      }\n    ',
          ]
        )),
      error ? theme.systemColors.error(1) : theme.transparent[10],
      focused ? '100%' : '0%',
      error ? theme.systemColors.error(1) : color
    )
  );
};

exports.generateInputGeometricLine = generateInputGeometricLine;

var generateInputView = function generateInputView(_a) {
  var shape = _a.shape,
    $icon = _a.$icon,
    theme = _a.theme,
    $label = _a.$label,
    $size = _a.$size,
    $iconLeft = _a.$iconLeft;
  var geometricCss = styled_components_1.css(
    templateObject_10 ||
      (templateObject_10 = __makeTemplateObject(
        ['\n    background-color: transparent;\n    border-radius: 0px;\n  '],
        ['\n    background-color: transparent;\n    border-radius: 0px;\n  ']
      ))
  );
  var roundedCss = styled_components_1.css(
    templateObject_11 ||
      (templateObject_11 = __makeTemplateObject(
        ['\n    background-color: ', ';\n  '],
        ['\n    background-color: ', ';\n  ']
      )),
    theme.transparent[5]
  );
  var circularCss = styled_components_1.css(
    templateObject_12 ||
      (templateObject_12 = __makeTemplateObject(
        ['\n    background-color: ', ';\n  '],
        ['\n    background-color: ', ';\n  ']
      )),
    theme.transparent[5]
  );
  var paddingLeft = getInputGap({
    shape: shape,
    $size: $size,
  });

  switch (shape) {
    case components_1.SHAPES.geometric:
      return styled_components_1.css(
        templateObject_13 ||
          (templateObject_13 = __makeTemplateObject(
            [
              '\n        ',
              '\n        padding-top: ',
              'px;\n        padding-bottom: ',
              'px;\n        padding-left: ',
              'px;\n        padding-right: ',
              'px;\n      ',
            ],
            [
              '\n        ',
              '\n        padding-top: ',
              'px;\n        padding-bottom: ',
              'px;\n        padding-left: ',
              'px;\n        padding-right: ',
              'px;\n      ',
            ]
          )),
        geometricCss,
        $label ? constants_1.INPUT_PADDING_GEOMETRIC[$size].topWithLabel : 0,
        $label ? constants_1.INPUT_PADDING_GEOMETRIC[$size].bottomWidthLabel : 0,
        $iconLeft ? paddingLeft : constants_1.INPUT_PADDING_GEOMETRIC[$size].default,
        $icon ? paddingLeft : constants_1.INPUT_PADDING_GEOMETRIC[$size].default
      );

    case components_1.SHAPES.rounded:
      return styled_components_1.css(
        templateObject_14 ||
          (templateObject_14 = __makeTemplateObject(
            [
              '\n        ',
              '\n        border-radius: ',
              'px;\n        padding-top: ',
              'px;\n        padding-bottom: ',
              'px;\n        padding-left: ',
              'px;\n        padding-right: ',
              'px;\n      ',
            ],
            [
              '\n        ',
              '\n        border-radius: ',
              'px;\n        padding-top: ',
              'px;\n        padding-bottom: ',
              'px;\n        padding-left: ',
              'px;\n        padding-right: ',
              'px;\n      ',
            ]
          )),
        roundedCss,
        constants_1.INPUT_PADDING_ROUNDED[$size].borderRadius,
        $label
          ? constants_1.INPUT_PADDING_ROUNDED[$size].topWithLabel
          : constants_1.INPUT_PADDING_ROUNDED[$size].top,
        $label
          ? constants_1.INPUT_PADDING_ROUNDED[$size].bottomWidthLabel
          : constants_1.INPUT_PADDING_ROUNDED[$size].bottom,
        $iconLeft ? paddingLeft : constants_1.INPUT_PADDING_ROUNDED[$size].default,
        $icon ? paddingLeft : constants_1.INPUT_PADDING_ROUNDED[$size].default
      );

    case components_1.SHAPES.circular:
      return styled_components_1.css(
        templateObject_15 ||
          (templateObject_15 = __makeTemplateObject(
            [
              '\n        ',
              '\n        border-radius: ',
              'px;\n        padding-top: ',
              'px;\n        padding-bottom: ',
              'px;\n        padding-left: ',
              'px;\n        padding-right: ',
              'px;\n      ',
            ],
            [
              '\n        ',
              '\n        border-radius: ',
              'px;\n        padding-top: ',
              'px;\n        padding-bottom: ',
              'px;\n        padding-left: ',
              'px;\n        padding-right: ',
              'px;\n      ',
            ]
          )),
        circularCss,
        constants_1.INPUT_PADDING_CIRCULAR[$size].borderRadius,
        $label
          ? constants_1.INPUT_PADDING_CIRCULAR[$size].topWithLabel
          : constants_1.INPUT_PADDING_CIRCULAR[$size].top,
        $label
          ? constants_1.INPUT_PADDING_CIRCULAR[$size].bottomWidthLabel
          : constants_1.INPUT_PADDING_CIRCULAR[$size].bottom,
        $iconLeft ? paddingLeft : constants_1.INPUT_PADDING_CIRCULAR[$size].default,
        $icon ? paddingLeft : constants_1.INPUT_PADDING_CIRCULAR[$size].default
      );

    default:
      return styled_components_1.css(
        templateObject_16 || (templateObject_16 = __makeTemplateObject([''], ['']))
      );
  }
};

exports.generateInputView = generateInputView;

var generateInputColor = function generateInputColor(_a) {
  var theme = _a.theme,
    disabled = _a.disabled;

  if (disabled) {
    return styled_components_1.css(
      templateObject_17 ||
        (templateObject_17 = __makeTemplateObject(
          ['\n      ', ';\n\n      cursor: not-allowed;\n    '],
          ['\n      ', ';\n\n      cursor: not-allowed;\n    ']
        )),
      exports.generateTextDisabled
    );
  }

  return styled_components_1.css(
    templateObject_18 ||
      (templateObject_18 = __makeTemplateObject(
        ['\n    color: ', ';\n  '],
        ['\n    color: ', ';\n  ']
      )),
    theme.transparent[100]
  );
};

exports.generateInputColor = generateInputColor;

var generateLabelFontSize = function generateLabelFontSize(_a) {
  var theme = _a.theme,
    value = _a.value,
    focused = _a.focused,
    fixedLabel = _a.fixedLabel,
    $size = _a.$size;

  if (value || focused || fixedLabel || $size !== components_1.INPUT_SIZES.medium) {
    return styled_components_1.css(
      templateObject_19 ||
        (templateObject_19 = __makeTemplateObject(
          ['\n      ', ';\n      ', ';\n    '],
          ['\n      ', ';\n      ', ';\n    ']
        )),
      theme.fonts.static.caption,
      $size === components_1.INPUT_SIZES.medium ? 'transform: translate(0, 4px)' : ''
    );
  }

  return styled_components_1.css(
    templateObject_20 ||
      (templateObject_20 = __makeTemplateObject(
        ['\n    ', ';\n    ', ';\n  '],
        ['\n    ', ';\n    ', ';\n  ']
      )),
    theme.fonts.static.bodyL,
    $size === components_1.INPUT_SIZES.medium ? 'transform: translate(0, 12px)' : ''
  );
};

exports.generateLabelFontSize = generateLabelFontSize;

var generateLabelFontColor = function generateLabelFontColor(_a) {
  var theme = _a.theme,
    color = _a.color,
    value = _a.value,
    error = _a.error,
    focused = _a.focused,
    disabled = _a.disabled,
    fixedLabel = _a.fixedLabel,
    $size = _a.$size;

  if (disabled) {
    return styled_components_1.css(
      templateObject_21 ||
        (templateObject_21 = __makeTemplateObject(
          ['\n      ', ';\n    '],
          ['\n      ', ';\n    ']
        )),
      exports.generateTextDisabled
    );
  }

  if (error) {
    return styled_components_1.css(
      templateObject_22 ||
        (templateObject_22 = __makeTemplateObject(
          ['\n      color: ', ';\n    '],
          ['\n      color: ', ';\n    ']
        )),
      theme.input.error
    );
  }

  if (focused) {
    return styled_components_1.css(
      templateObject_23 ||
        (templateObject_23 = __makeTemplateObject(
          ['\n      color: ', ';\n    '],
          ['\n      color: ', ';\n    ']
        )),
      color
    );
  }

  if ((value || fixedLabel) && $size === components_1.INPUT_SIZES.medium) {
    return styled_components_1.css(
      templateObject_24 ||
        (templateObject_24 = __makeTemplateObject(
          ['\n      color: ', ';\n    '],
          ['\n      color: ', ';\n    ']
        )),
      theme.transparent[50]
    );
  }

  return styled_components_1.css(
    templateObject_25 ||
      (templateObject_25 = __makeTemplateObject(
        ['\n    color: ', ';\n  '],
        ['\n    color: ', ';\n  ']
      )),
    theme.transparent[75]
  );
};

exports.generateLabelFontColor = generateLabelFontColor;

var generateIconButtonSize = function generateIconButtonSize(_a) {
  var size = _a.size;
  return styled_components_1.css(
    templateObject_26 ||
      (templateObject_26 = __makeTemplateObject(
        ['\n    width: ', 'px;\n    height: ', 'px;\n  '],
        ['\n    width: ', 'px;\n    height: ', 'px;\n  ']
      )),
    constants_1.ICON_SIZE[size],
    constants_1.ICON_SIZE[size]
  );
};

exports.generateIconButtonSize = generateIconButtonSize;

var generateIconButtonPosition = function generateIconButtonPosition(_a) {
  var shape = _a.shape,
    size = _a.size;
  var translateY = (constants_1.LINE_HEIGHT[size] - constants_1.ICON_SIZE[size]) / 2;

  switch (shape) {
    case components_1.SHAPES.geometric:
      return styled_components_1.css(
        templateObject_27 ||
          (templateObject_27 = __makeTemplateObject(
            [
              '\n        bottom: 0;\n        transform: translate(\n          ',
              'px,\n          -',
              'px\n        ); //\u0432\u044B\u0441\u043E\u0442\u0430 \u0441\u0442\u0440\u043E\u043A\u0438 24 - 16\u0438\u043A\u043E\u043D\u043A\u0430 /2\n      ',
            ],
            [
              '\n        bottom: 0;\n        transform: translate(\n          ',
              'px,\n          -',
              'px\n        ); //\u0432\u044B\u0441\u043E\u0442\u0430 \u0441\u0442\u0440\u043E\u043A\u0438 24 - 16\u0438\u043A\u043E\u043D\u043A\u0430 /2\n      ',
            ]
          )),
        constants_1.INPUT_PADDING_GEOMETRIC[size].withIcon,
        translateY
      );
    // case INPUT_SIZES.medium:
    //   return css`
    //     top: 0;
    //     transform: translate(0, -50%);
    //   `;

    case components_1.SHAPES.rounded:
      return styled_components_1.css(
        templateObject_28 ||
          (templateObject_28 = __makeTemplateObject(
            ['\n        bottom: 0;\n        transform: translate(-', 'px, -', 'px);\n      '],
            ['\n        bottom: 0;\n        transform: translate(-', 'px, -', 'px);\n      ']
          )),
        constants_1.INPUT_PADDING_ROUNDED[size].withIcon,
        translateY
      );

    case components_1.SHAPES.circular:
      return styled_components_1.css(
        templateObject_29 ||
          (templateObject_29 = __makeTemplateObject(
            ['\n        bottom: 0;\n        transform: translate(-', 'px, -', 'px);\n      '],
            ['\n        bottom: 0;\n        transform: translate(-', 'px, -', 'px);\n      ']
          )),
        constants_1.INPUT_PADDING_CIRCULAR[size].withIcon,
        translateY
      );

    default:
      return styled_components_1.css(
        templateObject_30 || (templateObject_30 = __makeTemplateObject([''], ['']))
      );
  }
};

exports.generateIconButtonPosition = generateIconButtonPosition;

var generateIconColor = function generateIconColor(_a) {
  var theme = _a.theme,
    disabled = _a.disabled;

  if (disabled) {
    return styled_components_1.css(
      templateObject_31 ||
        (templateObject_31 = __makeTemplateObject(
          ['\n      svg {\n        fill: ', ';\n        cursor: not-allowed;\n      }\n    '],
          ['\n      svg {\n        fill: ', ';\n        cursor: not-allowed;\n      }\n    ']
        )),
      theme.transparent[25]
    );
  }

  return styled_components_1.css(
    templateObject_32 ||
      (templateObject_32 = __makeTemplateObject(
        ['\n    svg {\n      fill: ', ';\n    }\n  '],
        ['\n    svg {\n      fill: ', ';\n    }\n  ']
      )),
    theme.transparent[50]
  );
};

exports.generateIconColor = generateIconColor;

var generateHintColor = function generateHintColor(_a) {
  var theme = _a.theme,
    error = _a.error,
    disabled = _a.disabled;

  if (error) {
    return styled_components_1.css(
      templateObject_33 ||
        (templateObject_33 = __makeTemplateObject(
          ['\n      color: ', ';\n    '],
          ['\n      color: ', ';\n    ']
        )),
      theme.input.error
    );
  }

  if (disabled) {
    return styled_components_1.css(
      templateObject_34 ||
        (templateObject_34 = __makeTemplateObject(
          ['\n      color: ', ';\n    '],
          ['\n      color: ', ';\n    ']
        )),
      theme.transparent[25]
    );
  }

  return styled_components_1.css(
    templateObject_35 ||
      (templateObject_35 = __makeTemplateObject(
        ['\n    color: ', ';\n  '],
        ['\n    color: ', ';\n  ']
      )),
    theme.transparent[50]
  );
};

exports.generateHintColor = generateHintColor;

var generateInputHeight = function generateInputHeight(_a) {
  var $size = _a.$size;
  return styled_components_1.css(
    templateObject_36 ||
      (templateObject_36 = __makeTemplateObject(
        ['\n    height: ', 'px;\n  '],
        ['\n    height: ', 'px;\n  ']
      )),
    constants_1.LINE_HEIGHT[$size]
  );
};

exports.generateInputHeight = generateInputHeight;

var generateInputFontSize = function generateInputFontSize(_a) {
  var $size = _a.$size,
    theme = _a.theme;

  switch ($size) {
    case components_1.INPUT_SIZES.xsmall:
      return theme.fonts.static.caption;

    case components_1.INPUT_SIZES.small:
      return theme.fonts.static.bodyM;

    case components_1.INPUT_SIZES.medium:
      return theme.fonts.static.bodyL;

    default:
      return '';
  }
};

exports.generateInputFontSize = generateInputFontSize;

var generateLabelPosition = function generateLabelPosition(_a) {
  var $size = _a.$size;

  switch ($size) {
    case components_1.INPUT_SIZES.xsmall:
    case components_1.INPUT_SIZES.small:
      return styled_components_1.css(
        templateObject_37 ||
          (templateObject_37 = __makeTemplateObject(
            ['\n        display: block;\n      '],
            ['\n        display: block;\n      ']
          ))
      );

    case components_1.INPUT_SIZES.medium:
      return styled_components_1.css(
        templateObject_38 ||
          (templateObject_38 = __makeTemplateObject(
            [
              '\n        position: absolute;\n        left: 0;\n        transition-property: background, transform, color;\n        transition-timing-function: ease-out;\n        transition-duration: 0.15s;\n      ',
            ],
            [
              '\n        position: absolute;\n        left: 0;\n        transition-property: background, transform, color;\n        transition-timing-function: ease-out;\n        transition-duration: 0.15s;\n      ',
            ]
          ))
      );

    default:
      return '';
  }
};

exports.generateLabelPosition = generateLabelPosition;

var generateIconLeftPosition = function generateIconLeftPosition(_a) {
  var shape = _a.shape,
    size = _a.size;
  var translateY = (constants_1.LINE_HEIGHT[size] - constants_1.ICON_SIZE[size]) / 2;

  switch (shape) {
    case components_1.SHAPES.geometric:
      return styled_components_1.css(
        templateObject_39 ||
          (templateObject_39 = __makeTemplateObject(
            ['\n        bottom: 0;\n        transform: translate(', 'px, -', 'px);\n      '],
            ['\n        bottom: 0;\n        transform: translate(', 'px, -', 'px);\n      ']
          )),
        constants_1.INPUT_PADDING_GEOMETRIC[size].withIcon,
        translateY
      );

    case components_1.SHAPES.rounded:
      return styled_components_1.css(
        templateObject_40 ||
          (templateObject_40 = __makeTemplateObject(
            ['\n        bottom: 0;\n        transform: translate(', 'px, -', 'px);\n      '],
            ['\n        bottom: 0;\n        transform: translate(', 'px, -', 'px);\n      ']
          )),
        constants_1.INPUT_PADDING_ROUNDED[size].withIcon,
        translateY
      );

    case components_1.SHAPES.circular:
      return styled_components_1.css(
        templateObject_41 ||
          (templateObject_41 = __makeTemplateObject(
            ['\n        bottom: 0;\n        transform: translate(', 'px, -', 'px);\n      '],
            ['\n        bottom: 0;\n        transform: translate(', 'px, -', 'px);\n      ']
          )),
        constants_1.INPUT_PADDING_CIRCULAR[size].withIcon,
        translateY
      );

    default:
      return styled_components_1.css(
        templateObject_42 || (templateObject_42 = __makeTemplateObject([''], ['']))
      );
  }
};

exports.generateIconLeftPosition = generateIconLeftPosition;
var templateObject_1,
  templateObject_2,
  templateObject_3,
  templateObject_4,
  templateObject_5,
  templateObject_6,
  templateObject_7,
  templateObject_8,
  templateObject_9,
  templateObject_10,
  templateObject_11,
  templateObject_12,
  templateObject_13,
  templateObject_14,
  templateObject_15,
  templateObject_16,
  templateObject_17,
  templateObject_18,
  templateObject_19,
  templateObject_20,
  templateObject_21,
  templateObject_22,
  templateObject_23,
  templateObject_24,
  templateObject_25,
  templateObject_26,
  templateObject_27,
  templateObject_28,
  templateObject_29,
  templateObject_30,
  templateObject_31,
  templateObject_32,
  templateObject_33,
  templateObject_34,
  templateObject_35,
  templateObject_36,
  templateObject_37,
  templateObject_38,
  templateObject_39,
  templateObject_40,
  templateObject_41,
  templateObject_42;
